/* globals GIG */
/* eslint-env browser */

'use strict';

const { h } = require('phy');

const FetchHandler = require('../../deal/frontend/FetchHandler');
require('groupon-iframe-login/frontend/iframe_login_no_template');

const EducationDesktop = require('../components/education_desktop');
const InfoComponent = require('../components/information');
const SelectNotification = require('../components/notification');
const SelectWidgetBaseContainer = require('./select_widget_base_container');

const {
  SELECT_ENROLL_SUCCESS_MESSAGE,
  SELECT_ENROLL_FAILURE_MESSAGE,
  SELECT_ENROLL_CANCELLED_MESSAGE,
  SELECT_ENROLL_EXISTING_CARD_SRC,
  SELECT_ENROLL_ADD_CARD_SRC,
} = require('../utils/constants');

class SelectWidgetDesktopContainer extends SelectWidgetBaseContainer {
  constructor(props) {
    super(props);
    this.bindAll();
    this.state = {
      displayNotification: undefined,
      iframeHasError: null,
      isEnrolled: null,
      isIframeLoading: null,
      isUserStatusSet: null,
    };
  }

  bindAll() {
    this.handleOpenModalClick = this.handleOpenModalClick.bind(this);
    this.handleCloseModalClick = this.handleCloseModalClick.bind(this);
    this.setIframeHeight = this.setIframeHeight.bind(this);
    this.handleEnrollmentMessages = this.handleEnrollmentMessages.bind(this);
  }

  componentDidUpdate() {
    const {
      isUserStatusSet,
      isEnrolled,
      iframeHasError,
      isIframeLoading,
    } = this.state;
    const { touchRequest } = this.props;

    if (
      isUserStatusSet &&
      !touchRequest &&
      !isEnrolled &&
      !iframeHasError &&
      isIframeLoading === null
    ) {
      this.initializeEducation();
    } else if ((isEnrolled || iframeHasError) && this.$modalIframe) {
      this.$modalIframe.remove();
    }

    GIG.Alerts.init('.select-alerts');
  }

  componentDidUnmount() {
    window.removeEventListener('message', this.handleEnrollmentMessages);
  }

  setIframeHeight() {
    if (this.$modalIframe) {
      const iframeContentHeight = this.$modalIframe.contentWindow.document.body
        .scrollHeight;
      const { paddingTop, paddingBottom } = getComputedStyle(this.$modalIframe);
      this.$modalIframe.style.width = '100%';
      this.$modalIframe.height = `${
        iframeContentHeight + parseInt(paddingTop) + parseInt(paddingBottom)
      }px`;
    }
  }

  updateIframeHeightOnChange() {
    if (this.$modalIframe && this.$modalIframe.contentWindow.Parsley) {
      this.$modalIframe.contentWindow.Parsley.on('field:validated', () =>
        this.setIframeHeight()
      );
    }
  }

  showSelectNotification(displayNotification) {
    if (GIG.Modal.currentOpenModal()) GIG.Modal.close();
    this.setState({ displayNotification });
  }

  handleEnrollmentMessages(message) {
    message.preventDefault();
    switch (message.data) {
      case SELECT_ENROLL_SUCCESS_MESSAGE: {
        this.setIframeHeight();
        this.lazyLoadUserStatus();
        this.showSelectNotification('notification_success');
        break;
      }
      case SELECT_ENROLL_FAILURE_MESSAGE: {
        this.setIframeHeight();
        this.showSelectNotification('error_system');
        break;
      }
      case SELECT_ENROLL_CANCELLED_MESSAGE: {
        GIG.Modal.close();
        break;
      }
    }
  }

  getIframeSource() {
    return this.state.hasCards
      ? SELECT_ENROLL_EXISTING_CARD_SRC
      : SELECT_ENROLL_ADD_CARD_SRC;
  }

  hasIncorrectOrNoIframeSource() {
    return (
      this.$modalIframe &&
      this.$modalIframe.contentWindow &&
      !this.$modalIframe.contentWindow.location.pathname.match(
        this.getIframeSource()
      )
    );
  }

  fetchIframe() {
    const iframeHandler = new FetchHandler({
      url: this.getIframeSource(),
      requestOpts: {
        credentials: 'same-origin',
        contentType: 'text/html',
      },
      rawResponse: true,
      successHandlers: data =>
        data.text().then(d => {
          if (d && d.match('.select-error')) {
            this.setState({ iframeHasError: true });
          }
        }),
      errorHandlers: [],
    });
    iframeHandler.send();
  }

  checkIframeForErrors({ iframeLoaded }) {
    if (iframeLoaded) {
      if (
        this.$modalIframe.contentWindow.document.body.querySelector(
          '.select-error'
        )
      ) {
        this.setState({ iframeHasError: true });
        this.showSelectNotification('error_load');
      }
    } else {
      this.fetchIframe();
    }
  }

  setIframe() {
    if (this.hasIncorrectOrNoIframeSource()) {
      this.$modalIframe.onload = e => {
        if (e.target.src) {
          this.setState({ isIframeLoading: false });
          this.setIframeHeight();
          this.checkIframeForErrors({ iframeLoaded: true });
          this.updateIframeHeightOnChange();
        }
      };
      this.$modalIframe.src = this.getIframeSource();
      this.setState({ isIframeLoading: true });
    }
  }

  benefitsFetchSuccess(data) {
    if (data) {
      document.querySelector('#enrollment-modal-benefits').innerHTML =
        data.html;
    }
  }

  initializeBenefits() {
    const benefitsHandler = new FetchHandler({
      url: '/programs/select/benefits',
      requestOpts: {
        credentials: 'same-origin',
        method: 'get',
        contentType: 'application/json',
      },
      successHandlers: data => this.benefitsFetchSuccess(data),
      errorHandlers: [],
    });
    benefitsHandler.send();
  }

  openEducationModal() {
    if (this.state.iframeHasError) {
      this.showSelectNotification('error_load');
    } else {
      this.setIframe();
      GIG.Modal.open({ id: 'select-widget-enrollment-modal' });
    }
  }

  openLoginIframe() {
    if (window.payload.iframeLogin && window.IframeLogin.$iframe) {
      window.IframeLogin.openModal();
      window.IframeLogin.updateHeight(
        window.IframeLogin.$iframe.contentWindow.document.body.scrollHeight
      );
    }
  }

  handleOpenModalClick(e) {
    e.preventDefault();
    this.state.isLoggedIn ? this.openEducationModal() : this.openLoginIframe();
  }

  handleCloseModalClick() {
    if (this.hasIncorrectOrNoIframeSource()) {
      this.$modalIframe.contentWindow.document.body.innerHTML = '';
    }
  }

  initializeEducation() {
    this.$educationModal = document.querySelector(
      '#select-widget-enrollment-modal'
    );

    if (this.state.isLoggedIn) {
      this.initializeBenefits();
      this.checkIframeForErrors({ iframeLoaded: false });
      window.addEventListener('message', this.handleEnrollmentMessages);
      GIG.Modal.onClose(
        this.handleCloseModalClick,
        'select-widget-enrollment-modal'
      );
    } else if (window.payload.iframeLogin) {
      window.IframeLogin.lazyLoadIframe();
    }
  }

  lazyLoadUserStatus() {
    const handler = new FetchHandler({
      url: '/deals/user_proxy/select_enrollment_status',
      requestOpts: { credentials: 'same-origin' },
      successHandlers: userStatus =>
        this.setState({ isUserStatusSet: true, ...userStatus }),
      errorHandlers: () => this.setState({ isUserStatusSet: false }),
    });
    handler.send();
  }

  getWidget() {
    return this.state.isEnrolled
      ? h(InfoComponent, { ...this.props, hideByDefault: false })
      : h(EducationDesktop, {
          ...this.props,
          handleLearnMoreClick: this.handleOpenModalClick,
          iframeRef: el => (this.$modalIframe = el),
          iframeLoading: this.state.isIframeLoading,
        });
  }

  render() {
    return this.state.isUserStatusSet
      ? h(
          'div',
          h(SelectNotification, {
            ...this.props,
            displayNotification: this.state.displayNotification,
          }),
          this.getWidget()
        )
      : h('div');
  }
}

module.exports = SelectWidgetDesktopContainer;
